export * from './validate-precio.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/validate-precio/index.ts